import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexto/ContextoTema';
import { DataProvider } from './contexto/ContextoDatos';

// Pages
import Home from './paginas/Inicio';
import ServicesIndex from './paginas/Servicios/IndiceServicios';
import ServiceDetail from './paginas/Servicios/DetalleServicio';
import ProductsIndex from './paginas/Productos/IndiceProductos';
import MagnoCategoria from './paginas/Productos/MagnoCategoria';
import ProductDetail from './paginas/Productos/DetalleProducto';
import AvisoPrivacidad from './paginas/AvisoPrivacidad';
import TerminosCondiciones from './paginas/TerminosCondiciones';
import Nosotros from './paginas/Nosotros';
import Proyectos from './paginas/Proyectos';
import NotFound from './paginas/PaginaNoEncontrada';
import FAQPage from './paginas/FAQ';

// Styles
import './estilos/globales.css';

function App() {
  return (
    <ThemeProvider>
      <DataProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />

            {/* About Route */}
            <Route path="/nosotros" element={<Nosotros />} />

            {/* Services Routes */}
            <Route path="/servicios" element={<ServicesIndex />} />
            <Route path="/servicios/:serviceSlug" element={<ServiceDetail />} />

            {/* Products Routes */}
            <Route path="/productos" element={<ProductsIndex />} />
            <Route path="/productos/macro/:macroSlug" element={<MagnoCategoria />} />
            <Route path="/productos/:productSlug" element={<ProductDetail />} />

            {/* About Route */}
            <Route path="/nosotros" element={<Nosotros />} />

            {/* FAQ Route */}
            <Route path="/preguntas-frecuentes" element={<FAQPage />} />

            {/* Projects Route */}
            <Route path="/proyectos" element={<Proyectos />} />

            {/* Legal Routes */}
            <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
            <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />

            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </DataProvider>
    </ThemeProvider>
  );
}

export default App;
